import React, { useEffect } from 'react'
import { makeAutoObservable } from 'mobx'
import { observer } from 'mobx-react-lite'
import AdminContentEditPopupComponent from './../../../../components/adminShared/AdminContentEditPopupComponent'
import ContentService from './../../../../shared/services/Content.service'
import UserProfileService from './../../../../shared/services/UserProfile.service'

import './DashboardVideo.scss'

const YT_URL_REGEX =
  /https:\/\/www.youtube.com\/(?:(?:[^\s()<>]+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))?\))+(?:\((?:[^\s()<>]+|(?:\(?:[^\s()<>]+\)))?\)|[^\s`!()[]{};:'".,<>?«»“”‘’]))?/

class VideoStore {
  videos = {}

  constructor() {
    makeAutoObservable(this)
  }

  fetchVideoById = async videoId => {
    return new Promise((resolve, reject) => {
      this.videos[videoId] = false

      if (videoId > 0) {
        return ContentService.getPageById(videoId).then(
          url => resolve((this.videos[videoId] = (url && url?.content) || '')),
          error => reject(error)
        )
      }

      return Promise.reject('Invalid Video ID supplied.')
    })
  }
}

const Store = new VideoStore()

const DashboardVideo = ({ videoId, onSuccess, onError }) => {
  const { videos, fetchVideoById } = Store,
    video = videoId && videos?.[videoId],
    isAdmin = UserProfileService.isA(['internal-admin', 'internal-staff', 'system-admin'])

  useEffect(() => {
    if (videoId && typeof video === 'undefined')
      fetchVideoById(videoId).then(
        url => {
          url ? onSuccess() : onError()
        },
        () => {
          onError()
        }
      )
  }, [videoId, video, fetchVideoById, onError, onSuccess])

  const renderVideo = () => {
    if (video && `${video}`.match(/(vimeo\.com)/gi))
      return (
        <>
          <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
            <iframe
              src={video.replace(/(<([^>]+)>)/gi, '')}
              frameBorder='0'
              allow='autoplay; fullscreen; picture-in-picture'
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
              title='Rick Banville Testimonial'
            ></iframe>
          </div>
          {video ? <br /> : <></>}
        </>
      )

    if (video && `${video}`.match(/(youtube\.com|ytimg\.com|googlevideo\.com|youtu\.be)/gi))
      return (
        <>
          <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
            <iframe
              width='100%'
              height='auto'
              src={video.match(YT_URL_REGEX)}
              title='USABG Video Player'
              frameBorder='0'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen
            />
          </div>
          {video ? <br /> : <></>}
        </>
      )

    return video ? <div dangerouslySetInnerHTML={{ __html: video }} /> : <></>
  }

  return (
    <div id='DashboardVideoComponent'>
      {renderVideo()}
      {isAdmin && videoId > 0 ? (
        <AdminContentEditPopupComponent
          type='RTE'
          iconPosition='top-right'
          iconStyle={{ transform: 'translate(10%, 0)' }}
          pageId={videoId}
          color='primary'
          callback={() => fetchVideoById(videoId)}
        />
      ) : (
        <></>
      )}
    </div>
  )
}

export default observer(DashboardVideo)
